import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@shared/services/api";
import { ADMIN_DASHBOARD_KEYS } from "@shared/constants/queryKeys";
import type { DashboardMetrics, DashboardMetricsParams } from "@admin/types/dashboard";

type DashboardMetricsResponse = {
  success?: boolean;
  data: DashboardMetrics;
  message?: string;
};

export function useDashboardMetrics(params: DashboardMetricsParams = {}) {
  const {
    period = "30d",
    groupBy = "day",
    topProductsLimit = 10,
  } = params;

  return useQuery({
    queryKey: ADMIN_DASHBOARD_KEYS.metrics({ period, groupBy, topProductsLimit }),
    queryFn: async (): Promise<DashboardMetrics> => {
      const searchParams = new URLSearchParams({
        period,
        groupBy,
        topProductsLimit: String(topProductsLimit),
      });

      const response = await apiClient.get<DashboardMetricsResponse>(
        `/dashboard/metrics?${searchParams.toString()}`
      );

      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutos (mismo que el cache del backend)
  });
}

